export default __webpack_public_path__ + "static/bed-bath-beyond-4-a-c5fc85770ccb2b7ee76179dbf936f6c2.gif";